// extracted by mini-css-extract-plugin
module.exports = {"byline":"styles_byline__pKAmX"};